(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    class StandardProductCheckout extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-standard-checkout-button]');
      this.error = this.querySelector('[data-standard-checkout-error]');
      this.handleCheckout = this.handleCheckout.bind(this);
      this.button?.addEventListener('click', this.handleCheckout);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleCheckout);
    }

    async handleCheckout() {
      const form = this.closest('form');
      if (!form || !form.checkValidity()) {
        form?.reportValidity();
        return;
      }

      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || result.message || 'Unable to continue to checkout.');
        }

        window.location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        this.error.textContent = error.message;
        this.error.hidden = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('standard-product-checkout')) {
    customElements.define('standard-product-checkout', StandardProductCheckout);
  }
  } catch(e) { console.error(e); }
})();

})();
